import { Controller } from "react-hook-form";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const ControlledCheckbox = ({
	className,
	control,
	name,
	label,
	error,
	defaultValue,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ field: { onChange, value } }) => (
				<FormControlLabel
					className={className}
					error={error ? 1 : 0}
					control={
						<Checkbox
							name={name}
							checked={!!value}
							{...rest}
							onChange={(value) => {
								onChange(value);
								if (rest?.onChange) {
									rest.onChange();
								}
							}}
						/>
					}
					label={label}
				/>
			)}
		/>
	);
};

export default ControlledCheckbox;
